import { createApp } from 'vue'
import app from './app.vue';
import {getPropsData} from '../../utils/helper-functions';

export default () => {
  document.querySelectorAll('product-card-new').forEach((el) => {
    const propData = getPropsData(el.closest('section').nextElementSibling);
    createApp(app, {data:propData}).mount(el);
  })
}